import React from 'react';
import clsx from 'clsx';
import {Grid} from '@mui/material';
import { Card, Divider, Typography } from '@curves/ui-base';

import {ORDER_INVOICE_ISSUING_TYPE} from '@Constants/';
import {formatMobileNumber, isEqual} from '@Util/utils';
import {ReadTextField} from '@Local/Components';
import OrderInvoiceTypeInfo from '@Local/Orders/OrderViewPage/Components/OrderInvoiceTypeInfo';
/**
 * 訂單顧客資訊區塊組件
 *
 * 功能：
 * - 顯示訂單相關的顧客資訊
 * - 包含姓名、電話、身分等資訊
 * - 支援發票類型資訊顯示
 *
 * @component
 * @param {Object} props - 組件屬性
 * @param {string} props.className - 自定義樣式類名
 * @param {Object} props.infoData - 訂單資料
 * @param {Object} props.paymentData - 付款資料
 * @returns {JSX.Element} 顧客資訊區塊
 */
const OrderCustomerInfoSection = ({className, infoData, paymentData}) => {
    return (
        <Card className={clsx("px-3 pt-2 pb-3", className)}>
            <Card.CardContent>
                <Typography variant="body1" className={'mb-2'}>
                    顧客資訊
                </Typography>
                <Grid spacing={2} container>
                    <Grid xs={6} item>
                        <ReadTextField label="姓名">
                            {infoData?.receiverName}
                        </ReadTextField>
                    </Grid>
                    <Grid xs={6} item>
                        <ReadTextField label="身分別">
                            {
                                infoData?.receiverTypeText
                            }
                            {
                                infoData?.memberNo ? (<span className={'font-color-3'}>：{infoData?.memberNo}</span>) : ""
                            }
                        </ReadTextField>
                    </Grid>
                    <Grid xs={6} item>
                        <ReadTextField label="聯絡電話">
                            {infoData?.issuingCellPhone ? formatMobileNumber(infoData?.issuingCellPhone) : ""}
                        </ReadTextField>
                    </Grid>
                    <Grid xs={6} item>
                        <ReadTextField label="Email">
                            {infoData?.issuingEmail}
                        </ReadTextField>
                    </Grid>
                </Grid>
                <Divider className={'mt-1 mb-2'} />
                <Typography variant="body1" className={'mb-2'}>
                    發票資訊
                </Typography>
                <Grid spacing={2} container>
                    <Grid xs={6} item>
                        <ReadTextField label="發票類型">
                            <OrderInvoiceTypeInfo invoiceCarrierTypeText={paymentData?.invoiceCarrierTypeText}
                                                  issuingType={paymentData?.issuingType}
                                                  issuingTypeText={paymentData?.issuingTypeText}/>
                        </ReadTextField>
                    </Grid>
                    {
                        isEqual(paymentData?.issuingType, ORDER_INVOICE_ISSUING_TYPE.DONATE) && (
                            <Grid xs={6} item>
                                <ReadTextField label="愛心碼">
                                    {paymentData?.donationCode}
                                </ReadTextField>
                            </Grid>
                        )
                    }
                    {
                        (isEqual(paymentData?.invoiceCarrierType, ORDER_INVOICE_ISSUING_TYPE.DUPLICATEUNIFORMINVOICE) || isEqual(paymentData?.invoiceCarrierType, ORDER_INVOICE_ISSUING_TYPE.TRIPLICATEUNIFORMINVOICE)) && (
                            <Grid xs={6} item>
                                <ReadTextField label="載具號碼">
                                    {paymentData?.invoiceCarrierNo}
                                </ReadTextField>
                            </Grid>
                        )
                    }
                    {
                        isEqual(paymentData?.issuingType, ORDER_INVOICE_ISSUING_TYPE.TRIPLICATEUNIFORMINVOICE) && (
                            <Grid xs={6} item>
                                <ReadTextField label="發票資訊">
                                    {`${paymentData?.taxID}, ${paymentData?.taxTitle}`}
                                </ReadTextField>
                            </Grid>
                        )
                    }
                </Grid>
            </Card.CardContent>
        </Card>
    )
};
export default OrderCustomerInfoSection;
